<template>
    <div class="main-content people" v-cloak>
        <div class="container">
            <div class="people">
                <div class="events-group" v-if="active_people_tab === 'adults'">
                    <div
                        class="events-group-sorting"
                        v-if="potential_guests_adults && potential_guests_adults.length > 0"
                    >
                        <div class="events-group-sorting-left">
                            <span v-if="sorted_by_label" class="icon icon-sort-down"></span>{{ sorted_by_label }}
                        </div>
                        <div class="events-group-sorting-right">
                            <icon-dropdown
                                @selected="do_action"
                                :options="[
                                    {
                                        label: 'Sorted by name asc',
                                        value: 'name_asc'
                                    },
                                    {
                                        label: 'Sorted by name desc',
                                        value: 'name_desc'
                                    }
                                ]"
                                icon_class="icon icon-sort"
                            ></icon-dropdown>
                        </div>
                    </div>
                    <div class="people-list" :style="{ height: `${adults_list_container_height}px` }">
                        <guest-select
                            v-if="potential_guests_adults && potential_guests_adults.length > 0"
                            @changed="person_checked"
                            v-for="(g, inx) in potential_guests_adults"
                            :key="g.id"
                            :event_person="g"
                        ></guest-select>
                        <div v-if="potential_guests_adults && potential_guests_adults.length === 0" class="no-results">
                            No adults to add
                        </div>
                    </div>
                </div>
                <div class="events-group" v-else>
                    <div class="events-group-sorting" v-if="potential_guests_kids && potential_guests_kids.length > 0">
                        <div class="events-group-sorting-left">
                            <span v-if="sorted_by_label" class="icon icon-sort-down"></span>{{ sorted_by_label }}
                        </div>
                        <div class="events-group-sorting-right">
                            <icon-dropdown
                                @selected="do_action"
                                :options="[
                                    {
                                        label: 'Sorted by name asc',
                                        value: 'name_asc'
                                    },
                                    {
                                        label: 'Sorted by name desc',
                                        value: 'name_desc'
                                    }
                                ]"
                                icon_class="icon icon-sort"
                            ></icon-dropdown>
                        </div>
                    </div>
                    <div class="people-list" :style="{ height: `${adults_list_container_height}px` }">
                        <guest-select
                            v-if="potential_guests_kids && potential_guests_kids.length > 0"
                            v-for="(g, inx) in potential_guests_kids"
                            :key="g.id"
                            @changed="person_checked"
                            :event_person="g"
                        ></guest-select>
                        <div v-if="potential_guests_kids && potential_guests_kids.length === 0" class="no-results">
                            No kids to add
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import guestSelect from "./guest-select-row";
import iconDropdown from "@/components/pages/icon-dropdown.vue";
import Vue from "vue";

export default {
    name: "guests-add",

    components: { iconDropdown, guestSelect },
    computed: {
        ...mapState("StoreEvent", ["event", "active_people_tab"]),
        ...mapGetters("StoreEvent", ["potential_guests_adults", "potential_guests_kids"])
    },
    data() {
        return {
            checked_ids: [],
            adults_list_container_height: 0,
            sorted_by: null,
            sorted_by_label: null,
            drop_shown: false
        };
    },

    watch: {
        event: {
            handler: function(new_val) {
                if (new_val.id) {
                    this.get_guests();
                }
            },
            deep: true
        },
        active_people_tab: {
            handler: function(new_val, old_val) {
                if (new_val !== old_val) {
                    this.sorted_by = null;
                    this.sorted_by_label = null;
                    this.get_guests();
                }
            },
            deep: true
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.params.id) {
                let data = {
                    sorted_by: false,
                    event_id: to.params.id
                };
                vm.get_event_guests(data);
                vm.set_guest_ids([]);
                vm.set_active_people_tab("adults");
            }
            next();
        });
    },

    mounted() {
        Vue.nextTick(() => {
            this.adults_list_container_height =
                window.innerHeight - document.getElementsByClassName("main-nav")[0].clientHeight - 110;
            if (
                document.getElementById("mobile-menu") &&
                document.getElementById("mobile-menu").style.display !== "none"
            ) {
                this.adults_list_container_height =
                    this.adults_list_container_height -
                    document.getElementsByClassName("footer-mobile")[0].clientHeight +
                    0;
            }
        });
    },
    methods: {
        ...mapMutations("StoreEvent", ["clear_task_event", "set_guest_ids", "set_active_people_tab"]),
        ...mapActions("StoreEvent", ["get_event_guests"]),
        do_action(pl) {
            this.sorted_by_label = pl.label;
            this.sorted_by = pl.value;
            this.get_guests();
        },
        person_checked(pl) {
            if (pl.event.target.checked) {
                if (!this.checked_ids.includes(pl.person_id)) {
                    this.checked_ids.push(pl.person_id);
                }
            } else {
                this.checked_ids = this.checked_ids.filter(item => item !== pl.person_id);
            }
            this.set_guest_ids(this.checked_ids);
        },
        get_guests() {
            if (this.event.id) {
                let data = {
                    sorted_by: this.sorted_by,
                    event_id: this.event.id
                };
                this.get_event_guests(data);
            }
        }
    }
};
</script>

<style scoped>
.people-list {
    overflow: auto;
    margin-right: -1.6rem;
}
</style>
